import { Spacer } from "Components/Common/Spacer/index";
import {
  TypographyT53,
  TypographyT54,
} from "Components/Common/Typography/index";
import {
  FlexWrapperT10,
  FlexWrapperT2,
} from "Components/Common/Wrapper/FlexWrapper";
import React, { Fragment } from "react";
import Moment from "moment";

const AdditionalFilesDetailsCard = (props) => {
  const { data } = props;
  const additionalData = data.additional_data || {};
  return (
    <Fragment>
      <FlexWrapperT10>
        <Wrapper>
          <Fragment>
            <FlexWrapperT2>
              <TypographyT53>Container Number :</TypographyT53>
              <TypographyT54>{additionalData.container_number}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>File Name :</TypographyT53>
              <TypographyT54>{additionalData.file_name}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>Invoice Number :</TypographyT53>
              <TypographyT54>{additionalData.invoice_number}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>Invoice Date:</TypographyT53>
              <TypographyT54>
                {additionalData.invoice_date
                  ? Moment(additionalData.invoice_date).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : "-"}
              </TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>Bill Entry Date:</TypographyT53>
              <TypographyT54>
                {additionalData.bill_entry_date
                  ? Moment(additionalData.bill_entry_date).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : "-"}
              </TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>Product Name :</TypographyT53>
              <TypographyT54>{additionalData.product_name}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>Plant Code :</TypographyT53>
              <TypographyT54>{additionalData.plant_code}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>STO/SO Number :</TypographyT53>
              <TypographyT54>{additionalData.sto_number}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>Tank Number :</TypographyT53>
              <TypographyT54>{additionalData.tank_number}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>Invoice Rate :</TypographyT53>
              <TypographyT54>{additionalData.invoice_rate}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
            <FlexWrapperT2>
              <TypographyT53>Invoice Value :</TypographyT53>
              <TypographyT54>{additionalData.invoice_value}</TypographyT54>
            </FlexWrapperT2>
            <Spacer spacing={"2px"} />
          </Fragment>
        </Wrapper>
        <Wrapper>
          <FlexWrapperT2>
            <TypographyT53>Bill Of Entry Number :</TypographyT53>
            <TypographyT54>{additionalData.bill_of_entry_number}</TypographyT54>
          </FlexWrapperT2>
          <Spacer spacing={"2px"} />
          <FlexWrapperT2>
            <TypographyT53>Custom Exchage Rate :</TypographyT53>
            <TypographyT54>{additionalData.custom_exchage_rate}</TypographyT54>
          </FlexWrapperT2>
          <Spacer spacing={"2px"} />
          <FlexWrapperT2>
            <TypographyT53>Duty Paid:</TypographyT53>
            <TypographyT54>{additionalData.duty_paid}</TypographyT54>
          </FlexWrapperT2>
          <Spacer spacing={"2px"} />
          <FlexWrapperT2>
            <TypographyT53>TCF:</TypographyT53>
            <TypographyT54>{additionalData.tcf}</TypographyT54>
          </FlexWrapperT2>
          <Spacer spacing={"2px"} />
          <FlexWrapperT2>
            <TypographyT53>Bulk Quantity:</TypographyT53>
            <TypographyT54>{additionalData.bulk_quantity}</TypographyT54>
          </FlexWrapperT2>
          <Spacer spacing={"2px"} />
          <FlexWrapperT2>
            <TypographyT53>Alcoholic Quantity:</TypographyT53>
            <TypographyT54>{additionalData.alcoholic_quantity}</TypographyT54>
          </FlexWrapperT2>
        </Wrapper>
      </FlexWrapperT10>
    </Fragment>
  );
};

export default AdditionalFilesDetailsCard;

import styled from "@emotion/styled";

export const Wrapper = styled.div``;
